import { BackContext } from "@keepeek/commons";

export const initBackContextState: BackContext = {};
